import countries from "../../../data/countries"

export default country_code => country_code ?
  countries.find(({ code }) => country_code?.toLocaleUpperCase() === code) || {} :
  {}
